<template>
    <div>
        <el-cascader :size="size" :value="value1"
                     :options="categoryTree"
                     :props="props"
                     ref="bumenref"
                     placeholder="请选择分类"
                     @change="handleChange" clearable :disabled="disabled" style="width:100%"></el-cascader>
    </div>
</template>

<script>
import {categoryProductTree} from '@/api/product'
import {getParentIds} from '@/utils/common'
export default {
    name: '',
    props: {
        value: {
            default: 0
        },
        disabled: {
            type:Boolean,
            default: false
        },
        size:{
            default:'normal'
        }
    },
    data(){
        return {
            categoryTree: [],
            props: {
                // expandTrigger: 'hover',
                value: 'id',
                label: 'name',
                children: 'child',
                checkStrictly: true
            },
            // value1: [1]
            // value1: null
        }
    },
    methods: {
        getCategoryTree() {
            categoryProductTree({}).then(response=>{
                if(response.code!=200)
                    return this.$message.error('获取产品分类树失败！')
                //console.log('获取产品分类树结果',response)
                this.categoryTree = response.data
                // this.categoryTree.unshift({id: null,name: '请选择分类'})
            })
        },
        handleChange(val) {
            // console.log(val)
            if (val.length>0) {
                // val = [1级id, 2级id, 3级id....]
                var label = this.$refs.bumenref.getCheckedNodes()[0].pathLabels
                this.$emit('nodeChange', val, label)
            }else{
                this.$emit('nodeChange', val, '')
            }
        }
    },
    watch: {
        /*value: {
            handler: function () {
                this.value1 = getParentIds(this.categoryTree, this.value)
                console.log('设定值', this.value1)
            }
        }*/
    },
    computed: {
        value1(){
            return getParentIds(this.categoryTree, this.value)
        }
    },
    created() {
        this.getCategoryTree()
    }
}
</script>

<style scoped>

</style>
